import { Action } from 'redux';

import { IMetricDataPoints, IMetricFailure } from '../../ts/ServerApi/types/IMetricDataList';

export enum MetricsDataActionTypes {
  REQUEST_START = 'METRICS/DATA/REQUEST_START',
  REQUEST_SUCCEEDED = 'METRICS/DATA/REQUEST_SUCCEEDED',
  REQUEST_FAILED = 'METRICS/DATA/REQUEST_FAILED',
  CLEAR = 'METRICS/DATA/CLEAR'
}

export interface MetricsDataRequestStartAction extends Action {
  type: MetricsDataActionTypes.REQUEST_START;
  ids: ReadonlyArray<string>;
}

export const metricsDataRequestStart = (ids: ReadonlyArray<string>): MetricsDataRequestStartAction => {
  return {
    type: MetricsDataActionTypes.REQUEST_START,
    ids
  };
};

type DataPointsById = { [id: string]: IMetricDataPoints };

export interface MetricsDataRequestSucceededAction extends Action {
  type: MetricsDataActionTypes.REQUEST_SUCCEEDED;
  dataPointsById: DataPointsById;
}

export const metricsDataRequestSucceeded = (dataPointsById: DataPointsById): MetricsDataRequestSucceededAction => {
  return {
    type: MetricsDataActionTypes.REQUEST_SUCCEEDED,
    dataPointsById
  };
};

type FailuresById = { [id: string]: IMetricFailure };

export interface MetricsDataRequestFailedAction extends Action {
  type: MetricsDataActionTypes.REQUEST_FAILED;
  failuresById: FailuresById;
}

export const metricsDataRequestFailed = (failuresById: FailuresById): MetricsDataRequestFailedAction => {
  return {
    type: MetricsDataActionTypes.REQUEST_FAILED,
    failuresById
  };
};

export interface MetricsDataClearAction {
  type: MetricsDataActionTypes.CLEAR;
}

export const clearMetricsData = (): MetricsDataClearAction => {
  return {
    type: MetricsDataActionTypes.CLEAR
  };
};

export type MetricsDataAction =
  MetricsDataRequestStartAction
  | MetricsDataRequestSucceededAction
  | MetricsDataRequestFailedAction
  | MetricsDataClearAction;
